import React, { useMemo, useState } from 'react';
import {
  Button,
  Image,
  message,
  Form,
  Input,
  Flex,
  Radio,
  InputNumber,
  Switch,
  Badge,
  Row,
  Col,
  Card,
  Modal,
} from 'antd';
import IntlMessage from '../../../components/IntlMessage';
import { CKEditor } from '@ckeditor/ckeditor5-react';
// import "./account.css";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { operator_params } from '../../../utils/constant';
import EditOperatorModal from './editModal';
import accountOperatorApi from '../../../api/account';
import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const AccountInfo = (props) => {
  const { account, isEdit, setIsEdit, onReload } = props;
  const [imgUrl, setImgUrl] = useState(null);
  const [check, setcheck] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imgs, setImgs] = useState(false);
  const queryClient = useQueryClient();

  const intl = useIntl();

  const [form] = Form.useForm();
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  let initialValues = {
    ...account,
    user_id: account?.userId ?? '',
    hotline: account?.hotline ?? '',
    meta_data:
      account && account.params
        ? operator_params.map((key) => ({
            [key]:
              account && account.params
                ? JSON.parse(account.params)[key] || null
                : null,
          }))
        : operator_params &&
          operator_params.map((key) => ({
            [key]: null,
          })),
  };

  const fileList = useMemo(() => {
    return account?.image
      ? [
          {
            uid: '1',
            name: 'xxx.png',
            status: 'done',
            url: account?.image,
          },
        ]
      : [];
  }, [account]);

  const handleChange = (v, f) => {
    setImgUrl(f);
  };

  const updateMutateAccount = useMutation({
    mutationFn: (payload) => accountOperatorApi.update(account?.id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account'] });
      setLoading(false);
      message.success('Updated successfully');
      onReload();
    },
    onError: (error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      setLoading(false);
    },
  });

  const handleSubmit = () => {
    // setLoading(true);

    form
      .validateFields()
      .then((values) => {
        let data = { ...values };
        delete data?.image;
        if (data.mobile) {
          data.phone = data.mobile;
        }
        if (!check) {
          delete data.password;
        }
        let combinedObject = {};
        account &&
          data.meta_data.forEach((item) => {
            Object.keys(item).forEach((key) => {
              combinedObject[key] = item[key];
              // console.log(item[key]);
            });
          });

        if (combinedObject) {
          data = {
            ...data,
            params: JSON.stringify(combinedObject),
          };
        }

        const payload = new FormData();
        Object.keys(data).forEach((key) => {
          payload.append(key, data[key]);
        });
        if (imgs) {
          payload.append('image', imgs);
        }
        // console.log("combinedObject: ", JSON.stringify(combinedObject));
        // if (values.meta_data) {
        //   payload.delete("meta_data");
        //   const arrToObj = Object.assign({}, ...values.meta_data);
        //   // payload.append("meta_data", JSON.stringify(arrToObj));
        // }

        if (account) {
          // console.log("check: ", values.meta_data);
          // accountOperatorApi
          //   .update(account?.id, payload)
          //   .then(() => {
          //     setLoading(false);
          //     message.success("Updated successfully");
          //     onReload();
          //   })
          //   .catch((error) => {
          //     console.error(error);
          //     Modal.error({
          //       title: error.data.message,
          //       okText: intl.formatMessage({ id: "global.close" }),
          //     });
          //     setLoading(false);
          //   });
          updateMutateAccount.mutate(payload);
        }
      })
      .catch(() => setLoading(false));
  };

  const onChangeDescription = (event, editor) => {
    const data = editor.getData();
    form.setFieldsValue({ description: data });
  };

  return (
    <Form
      name="basic"
      labelAlign="left"
      {...layout}
      form={form}
      style={{ width: 1500, maxWidth: 1500 }}
      initialValues={initialValues}
      autoComplete="off">
      <Card title={<IntlMessage id="global.company_info" />} bordered={true}>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label={<IntlMessage id="global.title" />}
              name="title"
              style={{ marginTop: 20 }}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={<IntlMessage id="global.short_name" />}
              name="short_name"
              style={{ marginTop: 20 }}>
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label={<IntlMessage id="global.firstname" />}
              name="firstname"
              style={{ marginTop: 20 }}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={<IntlMessage id="global.lastname" />}
              name="lastname"
              style={{ marginTop: 20 }}>
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label={<IntlMessage id="global.phone" />}
              name="phone"
              style={{ marginTop: 20 }}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={<IntlMessage id="global.hotline" />}
              name="hotline"
              style={{ marginTop: 20 }}>
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label={<IntlMessage id="global.email" />}
              name="email"
              style={{ marginTop: 20 }}>
              <Input readOnly />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              label={<IntlMessage id="global.description" />}
              name="description"
              style={{ marginTop: 20 }}
              labelCol={{ span: 4 }}>
              {/* <CKEditor
                editor={ClassicEditor}
                onChange={onChangeDescription}
                data={account?.description || ""}
                disabled={!isEdit}
              /> */}
              <Input.TextArea
                placeholder="Input description"
                autoSize={{ minRows: 6 }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      <br />
      <Card
        title={<IntlMessage id="global.booking_settings" />}
        bordered={true}>
        <Form.List name="meta_data">
          {(fields, { add }) => (
            <>
              {fields.map((field, index) => {
                const socialName = operator_params[index];

                if (socialName === 'allow_change_order_after_departure_hour') {
                  return (
                    <Form.Item
                      key={field.key}
                      label={<IntlMessage id={`global.${socialName}`} />}
                      name={[index, socialName]}
                      rules={[
                        {
                          message: <IntlMessage id={`global.numberfield`} />,
                          pattern: new RegExp(/^[0-9]+$/),
                        },
                      ]}>
                      <InputNumber
                        min={0}
                        disabled={
                          account?.params &&
                          JSON.parse(account?.params)[
                            'allow_change_order_after_departure'
                          ] === '0'
                        }
                      />
                    </Form.Item>
                  );
                } else if (socialName === 'limit_order_start_time') {
                  return (
                    <Form.Item
                      key={field.key}
                      label={<IntlMessage id={`global.${socialName}`} />}
                      name={[index, socialName]}
                      rules={[
                        {
                          message: <IntlMessage id={`global.numberfield`} />,
                          pattern: new RegExp(/^[0-9]+$/),
                        },
                      ]}>
                      <Input style={{ width: 300 }} />
                    </Form.Item>
                  );
                } else if (socialName === 'tax_rate') {
                  return (
                    <Form.Item
                      key={field.key}
                      label={<IntlMessage id={`global.${socialName}`} />}
                      name={[index, socialName]}
                      rules={[
                        {
                          message: <IntlMessage id={`global.numberfield`} />,
                          pattern: new RegExp(/^[0-9]+$/),
                        },
                      ]}>
                      <InputNumber min={0} />
                    </Form.Item>
                  );
                } else {
                  return (
                    <Form.Item
                      label={<IntlMessage id={`global.${socialName}`} />}
                      name={[index, socialName]}>
                      <Radio.Group name="radiogroup">
                        <Radio value={'1'}>
                          <IntlMessage id="global.active" />
                        </Radio>
                        <Radio value={'0'}>
                          <IntlMessage id="global.inactive" />
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  );
                }
              })}
            </>
          )}
        </Form.List>
      </Card>

      <Flex justify="flex-end">
        <Button
          htmlType="button"
          onClick={handleSubmit}
          type="primary"
          style={{ marginTop: 24 }}>
          {<IntlMessage id="global.edit" />}
        </Button>
      </Flex>
    </Form>
  );
};

export default AccountInfo;
